import { Component, TemplateRef, ViewChild } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbOffcanvas, NgbOffcanvasConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { FileService } from '../../../../../core/services/file.service';
import { GraduationService } from '../../../../../core/services/graduation.service';
import { ProfessorService } from '../../../../../core/services/professor.service';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import {FileService as myFileService} from '../../../../../core/utils/file-service'
import { NgxSpinnerService } from 'ngx-spinner';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { CycleService } from '../../../../../core/services/cycle.service';
import { PdfService } from '../../../../../core/services/pdf.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-professor',
    templateUrl: './professor.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule, NgxExtendedPdfViewerModule],
    styleUrls: ['./professor.component.css']
})
export class ProfessorComponent {
  pdfSrc = "https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf";
  @ViewChild('contentPDF') contentPDF:TemplateRef<any> | undefined
  buttonsPermission :any|undefined;
 search_text=""
  levelsFiltered:any[] =[]
  levels:any[] =[]
  cycles:any[] =[]
  data:any[] =[]
  skills:any[] =[]
  pjs:any[] =[]
  selectedCycles:any[] =[]
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  name=""
  cycleId:any
  loading=false
  tag="admin-professors-list"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any
  fileInput:any
  pdfViewLoader=false
 

  constructor(
    private cycleService:CycleService,
    private pdfService:PdfService,
    private spinnerService:NgxSpinnerService,
    private professorService:ProfessorService,
    private graduationService:GraduationService,
    private fileService:FileService,
    private toastrService:ToastrService,
    private lsService:LocalStorageService,
    configCanvas: NgbOffcanvasConfig, 
    private offcanvasService: NgbOffcanvas,
      config: NgbModalConfig,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;

     configCanvas.position = 'end';
     configCanvas.backdropClass = 'bg-info';
     configCanvas.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
this.getActions()
  }

  init(){
    this.getAll()
    this.getCycles()
  
  }

  getCycles(){
    this.cycleService.getByState(1,'recup').subscribe((res:any)=>{
      this.cycles=res.data
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des utilisateurs",err)
    })
  }
  getFile(code:any,folder:any,filename:any,css='details-panel'){
    this.spinnerService.show()
    this.pdfViewLoader=true
    this.fileService.get({
      folder:folder,
      code:code,
      filename:filename
    }).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: css, position: 'end'  });

    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des enseignants",err)

    })
  }

  getAll(){
    this.skills=[]
    this.pjs=[]
    this.selectedCycles=[]

    this.professorService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      res.data.forEach((element:any) => {
        element.files.forEach((element2:any) => {
          this.skills.push(element2.name)
        });
      });
      this.skills.push('Autre')
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des enseignants",err)
    })
  }


  store(value:any){
    this.loading=true
    
    this.professorService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
  update(value:any){
    this.loading=true

    this.professorService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.professorService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
})
  }
  removeFile(id:any){
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.graduationService.delete(id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des enseignants",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
    this.cycleId=this.levels.find((el:any)=>el.id == this.selected_data.level_id)?.cycle_id
    this.levelsFiltered= this.levels.filter((el:any)=>el.cycle_id == this.cycleId)
    el.cycles.forEach((element:any) => this.selectedCycles.push(element.cycle_id));
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }
  addFileContent(content:any){
    if(!this.verifyIfElementChecked()) return ;

    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.professorService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des enseignants",err)

      })
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }

  async upload(event:any){
    if(event.target.files.length>0){
     this.fileInput=event.target.files[0]
    }
  } 

  getPage(event:any){
    this.pg.p=event
  }

  addFile(){
  let formData= new FormData()
    formData.append('data',JSON.stringify(this.pjs))

    this.graduationService.store(formData).subscribe((res:any)=>{
      this.toastrService.success(res.message)
     // this.getFile(res.data?.code,res.data?.folder,res.data?.filename)
      this.getAll()
  },
  (err:any)=>{
    console.log(err)
      AppErrorShow.showError("Gestion des enseignants",err)

  })

  }


  async addElement(form:any){
    this.pjs.push({
      name:form.value.name=="Autre"?form.value?.other_name:form.value?.name,
      professor_id:this.selected_data.id,
      file:this.fileInput!=undefined ? await myFileService.fromArrayBufferToBase64(await myFileService.readFileAsync(this.fileInput)) :null
    })
    this.skills.push(form.value.name)
    form.resetForm()
  }


  removeItem(i:any){
    this.pjs.splice(i,1)
  }

  getPdf(){
    var professors:any[]=[];
    this.data.forEach((el:any)=> professors.push(el.id));
    this.pdfService.getProfessorList(professors).subscribe((res:any)=>{
      console.log(res);
      
      this.pdfViewLoader=false
      this.pdfSrc=res[0]
      this.offcanvasService.open(this.contentPDF,{  panelClass: 'details-panel', position: 'end'  });
  },
  (err:any)=>{
    console.log(err)
      AppErrorShow.showError("Gestion des cours",err)

  })
  }
}
